module.exports = __webpack_public_path__ + "static/img/13.0602679.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mohu/3/13.png
// module id = nk5s
// module chunks = 0